export default function (state) {
    state.Id = 0;
    state.PaymentDirection = 1;
    state.PaymentOperationID = 0;
    state.CategoryId = 0;
    state.PaymentTypeId = 0;
    state.CashId = 0;
    state.PaymentAccountId = 0;
    state.AccountNumber = '';
    state.Sum = 0;
    state.BankCommission = 0;
    state.PaymentDate = '';
    state.DocumentNumber = '';
    state.Comment = '';
    state.PaymentDetails = [];
}